export default function adjustDates(
  end_date,
  start_date = null,
  fallback_start_date = null
) {
    
  const now = new Date();
  const end = end_date
    ? new Date(end_date)
    : new Date(now.getTime() + 24 * 60 * 60 * 1000);
  let start = start_date
    ? new Date(start_date)
    : fallback_start_date
    ? new Date(fallback_start_date)
    : new Date(now.getTime() - 24 * 60 * 60 * 1000);

  const differenceInMs = end.getTime() - start.getTime();

  if (!start_date && differenceInMs < 24 * 60 * 60 * 1000) {
    // If start date is not provided and difference is less than 24 hours, adjust end date and add 24 hours
    end.setTime(end.getTime() + 24 * 60 * 60 * 1000);
  } else if (!end_date || differenceInMs < 24 * 60 * 60 * 1000) {
    // If end date is not provided or difference is less than 24 hours, adjust start date and subtract 24 hours
    start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
  }

  return [end.toISOString(), start.toISOString()];
}
